import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { phq4_choices, phq4_questions } from '../variables/assessments/phq4.js'
import { calculateTimepoint1 } from '../../functions/timepoint.js'
import StepperAssm from './stepper_assm'

import WarningIcon from '@material-ui/icons/Warning'
import Button from '@material-ui/core/Button'

class Phq4 extends Component {
  constructor() {
      super()
      //var [fields, setFields] = useState([{ value: null }])
      this.state = {
          status: 1, // 1: no data, 2: finished
          message: '',
          enable_phq4: -1,
          enable_who5: -1,
          uid: 0,
          start_time: Math.floor(new Date().getTime()/1000),
          start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
          next_step: 'who5',
          q1: -1,
          q2: -1,
          q3: -1,
          q4: -1,
      }
  }

  componentDidMount() {
    this.getAssmProcess()
  }

  getAssmProcess = () => {
    var timepoint = this.props.match.params.timepoint
    if(this.props.match.params.type === 'w') {
      axios({
        method: 'post',
        url: connectNode + 'patient/assessment/chk_each_assm',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          uid: this.props.authReducer.uid,
          type: this.props.match.params.type,
          timepoint: this.props.match.params.timepoint,
          assm: 'patients_assessment_phq4',
         }
      }).then((result) => {
        var calTimepoint = calculateTimepoint1(result['data'].timeline_start)
        if(this.props.match.params.timepoint > calTimepoint.current_week) {
          this.props.onLoadLocation('assessment_list_2', 'Sorry, something went wrong! Please only select available assessment in this page.')
          this.props.history.push('/member/assessment_list')
        } else if(this.props.match.params.timepoint == calTimepoint.current_week) {
          // Current timepoint => Fill the form //
          if(result['data'].status !== null) {
            if(result['data'].assm_status == 1) {
              // Completed //
              this.getCompletedData(2)
            } else {
              if(result['data'].status == 1 && result['data'].step !== 'phq4') {
                this.props.history.push('/member/assessment/'+result['data'].step+'/'+this.props.match.params.type+'/'+this.props.match.params.timepoint)
              }
            }
          } else {
            // Insert new row //
            axios({
              method: 'post',
              url: connectNode + 'patient/assessment/add_new_assm_process_wo_overview',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
              },
              data: {
                uid: this.props.authReducer.uid,
                type: this.props.match.params.type,
                timepoint: this.props.match.params.timepoint,
                next_step: 'phq4',
               }
            })
            .then((result) => { })
            this.setState({
              enable_phq4: result['data'].w_phq4,
              enable_who5: result['data'].w_who5
            })
          }
        } else {
          // Past timepoint //
          this.getCompletedData(3)
        }
      })
    } else {
      this.props.onLoadLocation('assessment_list_2', 'Sorry, something went wrong! Please only select available assessment in this page.')
      this.props.history.push('/member/assessment_list')
    }
  }

  getCompletedData = (status) => {
    axios({
      method: 'post',
      url: connectNode + 'patient/assessment/get_assm_data',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        type: this.props.match.params.type,
        timepoint: this.props.match.params.timepoint,
        frm: 'phq4',
       }
    }).then((result) => {
      this.setState({
        status: status,
        q1: result['data'].q1,
        q2: result['data'].q2,
        q3: result['data'].q3,
        q4: result['data'].q4,
      })
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    var timepoint = this.props.match.params.timepoint
    var type = this.props.match.params.type
    if(this.state.status === 1) {
      if(this.state.q1 === -1 || this.state.q2 === -1 || this.state.q3 === -1 ||
        this.state.q4 === -1) {
        this.setState({
          message: 'Please select all answers ',
        })
        window.scrollTo(0, 0)
      } else {
        axios({
          method: 'post',
          url: connectNode + 'patient/assessment/add_phq4',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            user: this.state,
            timepoint: timepoint,
            type: type,
            who5_status: this.state.enable_who5,
          }
        })
        .then((result) => {
          if(result['data'] === this.props.authReducer.uid) {
            if(this.state.enable_who5 == 1) {
              this.props.onLoadLocation('/member/assessment/who5/'+type+'/'+timepoint)
              this.props.history.push('/member/assessment/who5/'+type+'/'+timepoint)
            } else {
              this.props.onLoadLocation('assessment_list_1', 'Thank you for completing weekly questionnaires.')
              this.props.history.push('/member/assessment_list')
            }
          }
        })
      }
    } else {
      this.props.onLoadLocation('/member/assessment/who5/'+type+'/'+timepoint)
      this.props.history.push('/member/assessment/who5/'+type+'/'+timepoint)
    }
  }

  render() {

    return (
      <div className="assm_phq9 box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Weekly Questionnaire 1: PHQ-4
          </div>
          <StepperAssm activeStep={0} type={this.props.match.params.type} timepoint={this.props.match.params.timepoint} />
        </div>
        { this.state.message !== '' &&
        <div className="row warning_msg6">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>}
        <form onSubmit={this.handleSubmit}>
        <div className="row">
          <div className="small-12 columns box1">
            <div className="row show-for-medium bold">
              <div className="medium-8 columns">
                Over the LAST TWO WEEKS, how often have you been bothered by the following problems?
              </div>
              {phq4_choices.map(each =>
                <div className="medium-1 columns headerResize1" key={'p4'+each.value}>
                  {each.label}
                </div>
              )}
              <div className="small-12 columns">
                <div className="sep_line1">&nbsp;</div>
              </div>
            </div>

            {phq4_questions.map(eachQ =>
              <div className="row" key={'p4q'+eachQ.value}>
                <div className="small-12 medium-8 columns">
                  {eachQ.value}. {eachQ.label}
                </div>
                {phq4_choices.map(each =>
                  <div className="small-12 medium-1 columns" key={'p4c'+eachQ.value+each.value} >
                    <input type="radio" name={"q"+eachQ.value} value={each.value}
                    checked={this.state["q"+eachQ.value] == each.value && 'checked'}
                    disabled={this.state.status > 1 && 'disabled'}
                    onChange={(e) => this.handleChange(e)}/>
                    <span className="show-for-small-only">{each.label}</span>
                  </div>
                )}
                { eachQ.value < 4 &&
                <div className="small-12 columns">
                  <div className="sep_line2">&nbsp;</div>
                </div>}
              </div>
            )}

        </div>
        <div className="small-12 columns align_right">
          <Button variant="contained" color="primary" disableElevation
             onClick={this.handleSubmit} type="submit" className="submit_1">
              { this.state.status === 1 ? 'Submit' : 'Next' }
          </Button>
        </div>
      </div>
      </form>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('patientstate STATE: ', state)
  //console.log("timepoint: "+this.props.match.params.timepoint)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('AddPatient mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Phq4)
